import styled from 'styled-components'
import H5 from 'syf-component-library/ui/typography/H5'
import query from 'syf-component-library/const/mediaQueries'
import { spacing } from 'syf-component-library/defaultTheme'

export const NotificationWrapper = styled.div`
  width: 350px;
  color: ${({ theme }) =>
    theme?.brandRefreshPhase >= 1
      ? 'var(--syfds-color-content-default)'
      : theme?.white};

  @media (${query.lessThanMedium}) {
    width: 350px;
    padding-bottom: ${spacing.base}px;
  }

  @media (${query.lessThanSmall}) {
    width: 100%;
    padding-bottom: ${spacing.base}px;
  }
`

export const NotificationHeader = styled(H5)`
  width: 193px;
  height: 28px;
  text-align: left;
`
